import api from './api';

// Loja do Devskin Marketplace ligada à conta (usada pelos fluxos e pelo blog)
export interface MarketplaceConnection {
  id: string;
  store_id: string;
  store_name: string | null;
  store_slug: string | null;
  store_url: string | null;
  api_key_masked: string | null;
  scopes: string[];
  webhook_mode: 'auto' | 'manual';
  has_webhook_secret: boolean;
  webhook_id: string | null;
  events: string[];
  status: 'connected' | 'waiting_secret' | 'error' | 'disconnected';
  last_error: string | null;
  last_event_at: string | null;
  last_event_name: string | null;
  events_received: number;
  receiver_url?: string;
  created_at: string;
  updated_at: string;
}

export interface ConnectResult {
  success: boolean;
  data: MarketplaceConnection;
  store: { id: string; name: string; slug: string; url: string | null; blog_url: string | null };
  webhook: { mode: 'auto' | 'manual'; registered: boolean; error: string | null };
  message: string;
}

export const marketplaceIntegrationService = {
  async list(): Promise<{ success: boolean; data: MarketplaceConnection[]; events: string[] }> {
    return (await api.get('/integrations/marketplace/connections')).data;
  },
  async connect(apiKey: string): Promise<ConnectResult> {
    return (await api.post('/integrations/marketplace/connections', { api_key: apiKey })).data;
  },
  async saveSecret(id: string, secret: string): Promise<{ success: boolean; data: MarketplaceConnection; message: string }> {
    return (await api.put(`/integrations/marketplace/connections/${id}/secret`, { secret })).data;
  },
  async test(id: string): Promise<{ success: boolean; data: { connection: MarketplaceConnection; key_ok: boolean; webhook_delivered: boolean | null }; message: string }> {
    return (await api.post(`/integrations/marketplace/connections/${id}/test`)).data;
  },
  async disconnect(id: string): Promise<{ success: boolean; message: string }> {
    return (await api.delete(`/integrations/marketplace/connections/${id}`)).data;
  },
};

export default marketplaceIntegrationService;
